export const TypographyService = {
    countChars,
}

/**
 * Counts the number of occurrences of a specific character in a given string.
 *
 * @function
 * @memberof TypographyService
 * 
 * @param {string} string - The string to search within.
 * @param {string} char - The single character to count.
 * @returns {number} The number of times the character appears in the string.
 *
 * @example
 * 
 * TypographyService.countChars("hello world", "l"); // returns 3
 */
function countChars(string, char) {
    return string.split(char).length - 1;
}
